import NiceModal from '@ebay/nice-modal-react';
import { enqueueSnackbar } from 'notistack';
import { createAction } from 'redux-actions';

import { getMessage } from '@gef-ui/localization/messages';

import MODALS from 'constants/modals';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { dialogs as raDialogs } from 'features/views/roboAdvisory/constants';

import { setRAAnalysis } from '../actions';
import * as types from '../actionTypes';
import { getCheckedRaAnalysis } from '../selectors';
import { dialogs as raHandoverDialogs } from './constants';
import { ROBO_ADVISORY_HANDOVER_FORM_NAME } from './form';

export const saveUserSubordinates = createAction(types.SAVE_USER_SUBORDINATES, (userSubordinates) => ({
	userSubordinates,
}));

export const openHandoverModal = () => (dispatch, getState) => {
	const selectedRAAnalysis = getCheckedRaAnalysis(getState());
	if (selectedRAAnalysis.length <= 20) {
		dispatch(dialog.actions.close(raDialogs.SELECT_AMOUNT_LIMIT_FOR_HANDOVER));
		NiceModal.show(MODALS.roboAdvisory_handover);
	} else {
		dispatch(dialog.actions.open(raDialogs.SELECT_AMOUNT_LIMIT_FOR_HANDOVER, null, dialog.constants.WARNING));
	}
};

export const fetchUsersSubordinates = () => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.userList, {
			queryParams: {
				userHierarchy: 'subordinate',
				sort: ['surname,asc', 'firstName,asc'],
				size: 1000,
			},
			onSuccess: [
				({ body }) =>
					() => {
						const data = body.data;
						if (!data || !Array.isArray(data)) return;
						dispatch(saveUserSubordinates(data));
					},
			],
		}),
	);
};

export const handoverSelectedRAAnalysis =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const formData = await getFormData(ROBO_ADVISORY_HANDOVER_FORM_NAME);

		dispatch(dialog.actions.close(raHandoverDialogs.NO_SUBORDINATE_TO_HANDOVER));

		const checkedRaAnalysis = getCheckedRaAnalysis(getState());
		const body = {
			analyses: checkedRaAnalysis,
			solverLogin: formData?.handoverTo,
		};

		dispatch(
			fetch.actions.post(fetch.constants.urls.raHandover, {
				body,
				onSuccess: [
					(response) => () => {
						const { redirectAnalysisOk } = response.body;
						const redirectOkCount = redirectAnalysisOk.length;
						const checkedAnalysisCount = checkedRaAnalysis.length;

						if (redirectOkCount === checkedAnalysisCount) {
							enqueueSnackbar(getMessage('toastr:raAnalysisSuccessfulHandover'), { variant: 'success' });
						} else {
							enqueueSnackbar(getMessage('toastr:raAnalysisUnsuccessfulHandover'), { variant: 'error' });
						}

						NiceModal.hide(MODALS.roboAdvisory_handover);

						const { queryParams, body } = fetch.selectors.getLastRequest(fetch.constants.urls.raList)(
							getState(),
						);

						dispatch(
							fetch.actions.post(fetch.constants.urls.raList, {
								queryParams,
								body,
								onSuccess: [
									(response) => () => {
										if (!response.body) return;
										const { data } = response.body;
										dispatch(setRAAnalysis(data));
									},
								],
							}),
						);
					},
				],
			}),
		);
	};
